export const PDF_BOOKING_LAYOUTS = ["summary", "compact", "detailed"];

export const DEFAULT_PDF_BOOKING_LAYOUT = "detailed";
